(function () {
  if (window.R13MobileFocusAtcInitialized) return;

  window.R13MobileFocusAtcInitialized = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const topThreshold = 18;

  function getProductInfo(sectionId) {
    return document.getElementById(`MainProduct-${sectionId}`) || document.querySelector('product-info[id^="MainProduct-"]');
  }

  function getScrollTarget(productInfo) {
    if (!productInfo) return null;

    return productInfo.querySelector('.product__info-container') || productInfo.querySelector('.product__title') || productInfo;
  }

  function getStickyOffset() {
    const announcement = document.querySelector('.announcement-bar-section');
    const header = document.querySelector('sticky-header, .shopify-section-header-sticky, header.header');
    const visibleHeights = [announcement, header].reduce((total, element) => {
      if (!element) return total;

      const styles = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const isPinned = styles.position === 'fixed' || styles.position === 'sticky';

      return isPinned && rect.height > 0 && rect.bottom > 0 ? total + rect.height : total;
    }, 0);

    return Math.max(72, Math.min(128, visibleHeights + 16));
  }

  function init(root) {
    const button = root.querySelector('[data-r13-mobile-focus-atc-button]');
    const productInfo = getProductInfo(root.dataset.sectionId);
    const scrollTarget = getScrollTarget(productInfo);
    let dismissed = false;
    let ticking = false;

    function shouldShow() {
      if (!mobileQuery.matches) return false;
      if (!scrollTarget) return false;

      const scrollY = window.scrollY || window.pageYOffset || 0;
      if (scrollY <= 2) dismissed = false;

      return !dismissed && scrollY <= topThreshold;
    }

    function updateVisibility() {
      ticking = false;
      root.classList.toggle('is-visible', shouldShow());
    }

    function requestVisibilityUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }

    button?.addEventListener('click', () => {
      const target = getScrollTarget(productInfo);
      if (!target) return;

      dismissed = true;
      updateVisibility();

      const targetTop = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth',
      });
    });

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    mobileQuery.addEventListener?.('change', requestVisibilityUpdate);

    root.hidden = false;
    updateVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-r13-mobile-focus-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
}());
